import type { Ref } from "vue";

export const FormStateKey = Symbol("Form state");

export interface FormState {
  submitting: Ref<boolean>;
  readonly: Ref<boolean>;
}
